import { useEffect, useState } from 'react';
import { storefrontService } from '../services/storefrontService.js';

let contentCache = null;

export function useContent() {
  const [content, setContent] = useState(contentCache);
  const [status, setStatus] = useState(contentCache ? 'ready' : 'loading');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (contentCache) return;
    let active = true;
    storefrontService.content()
      .then((payload) => {
        contentCache = payload;
        if (!active) return;
        setContent(payload);
        setStatus('ready');
      })
      .catch((err) => {
        if (!active) return;
        setError(err);
        setStatus('error');
      });

    return () => {
      active = false;
    };
  }, []);

  return { content, status, error };
}
